import { getSiteUrl } from "./site"

/** 安全域：命中则直接跳转，否则走 link 提示页。暂固定为 .metal.com、smm.cn */
const SAFE_DOMAINS: readonly string[] = [".metal.com", "smm.cn"]

/**
 * 判断 host 是否命中任一安全域：. 开头匹配该域及子域（如 .metal.com），否则匹配该域及子域（如 smm.cn）
 */
function isHostInSafeDomains(host: string, safeDomains: readonly string[] = SAFE_DOMAINS): boolean {
  const lower = host.toLowerCase()
  for (const rule of safeDomains) {
    const r = rule.toLowerCase()
    if (r.startsWith(".")) {
      const suffix = r.slice(1)
      if (lower === suffix || lower.endsWith("." + suffix)) return true
    } else {
      if (lower === r || lower.endsWith("." + r)) return true
    }
  }
  return false
}

/**
 * 校验目标链接是否符合安全域，不符合则返回 false，符合则返回 true
 * @param targetUrl 目标链接
 */
export function isSafeUrl(targetUrl: string): boolean {
  return isHostInSafeDomains(new URL(targetUrl, "https://www.metal.com").hostname)
}

/**
 * 校验目标链接是否符合安全域，不符合则返回 link 提示页，符合则返回原链接。安全域暂固定为 .metal.com、smm.cn
 * @param targetUrl 目标链接
 * @param locale 语言，用于构建 link 页 URL
 */
export function getLinkPageUrl(targetUrl: string, locale = "en"): string {
  if (!targetUrl || typeof targetUrl !== "string") return targetUrl
  const trimmed = targetUrl.trim()
  if (trimmed.startsWith("/") || trimmed.startsWith("#") || trimmed.startsWith("?")) return targetUrl
  try {
    const parsed = new URL(trimmed, "https://www.metal.com")
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return targetUrl
    if (isHostInSafeDomains(parsed.hostname)) return targetUrl
  } catch {
    return targetUrl
  }
  const base = getSiteUrl("www")
  return `${base}/${locale}/link?url=${encodeURIComponent(targetUrl)}`
}
